exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".template-description {\n  margin-top: 10px;\n  padding-left: 5%;\n}\n.template-description .spinner {\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/create/TemplateDescription.less
// module id = 3022
// module chunks = 0